module.exports = __webpack_public_path__ + "static/media/20.68c4c1ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/20.jpg
// module id = 181
// module chunks = 0